import actions from '../actions/sessions';
import base from './base';

const reducer = base(actions.types);
export default reducer;